import { useAuthStore } from '../store/authStore';
import type { SubscriptionPlan } from '../types';

export function usePlan(): SubscriptionPlan {
  return useAuthStore((s) => s.user?.subscriptionPlan) ?? 'starter';
}

export function useHasPlan(plans: SubscriptionPlan[]): boolean {
  const plan = usePlan();
  return plans.includes(plan);
}
